import React, { useEffect, useState, useContext, useRef } from "react";
import { AuthContext } from "../context/AuthContext";
import html2pdf from "html2pdf.js";
import GlobalLoading from '../components/GlobalLoading';
import "../styles/pin.css";

const GeneratedPins = () => {
  const { fetchGeneratedPins, updatePinStatus } = useContext(AuthContext);
  const [pins, setPins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState("notUsed");
  const [selectedDenomination, setSelectedDenomination] = useState("all");
  const [selectedNetwork, setSelectedNetwork] = useState("all");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const pinsPerPage = 10;

  const printRef = useRef();

  useEffect(() => {
    const loadPins = async () => {
      const result = await fetchGeneratedPins();
      if (result.error) {
        console.error("Error fetching pins:", result.error);
        setLoading(false);
        return;
      }
      setPins(result);
      setLoading(false);
    };
    loadPins();
  }, [fetchGeneratedPins]);

  const handleToggleStatus = async (pinId) => {
    const pin = pins.find((p) => p._id === pinId);
    const newStatus = pin.status === "used" ? "notUsed" : "used";

    setPins((prevPins) =>
      prevPins.map((p) =>
        p._id === pinId ? { ...p, status: newStatus } : p
      )
    );

    const result = await updatePinStatus(pinId, newStatus);
    if (result.error) {
      console.error("Error syncing pin status:", result.error);
    }
  };

  const handleExportPDF = () => {
    const element = printRef.current;
     // Hide all toggle buttons
    const buttons = element.querySelectorAll(".toggle-status-btn");
    buttons.forEach((btn) => (btn.style.display = "none"));
    const opt = {
      margin: 0.5,
      filename: "generated_pins.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };
    html2pdf().set(opt).from(element).save();
  };

  const denominations = [...new Set(pins.map(pin => pin.denomination))].sort((a, b) => a - b);
  const networks = [...new Set(pins.map(pin => pin.network))];

  const filteredPins = pins.filter((pin) => {
    return (
      pin.status === view &&
      (selectedDenomination === "all" || pin.denomination === selectedDenomination) &&
      (selectedNetwork === "all" || pin.network === selectedNetwork)
    );
  });

  const totalPages = Math.ceil(filteredPins.length / pinsPerPage);
  const paginatedPins = filteredPins.slice(
    (currentPage - 1) * pinsPerPage,
    currentPage * pinsPerPage
  );

  
      if (loading) return <GlobalLoading />

  return (
    <div className="pin-container">
      {/* Export as PDF button */}
      <button onClick={handleExportPDF} className="export-btn">
        Export as PDF
      </button>

      {/* Filter Buttons */}
      <div className="filters-section">
        <div className="filter-group">
          {["notUsed", "used"].map((status) => (
            <button
              key={status}
              onClick={() => setView(status)}
              className={`filter-button ${view === status ? "active" : ""}`}
            >
              {status === "notUsed" ? "Not Used" : "Used"}
            </button>
          ))}
        </div>

        <div className="filter-group">
          <button
            onClick={() => setSelectedDenomination("all")}
            className={`filter-button ${selectedDenomination === "all" ? "active" : ""}`}
          >
            All Amounts
          </button>
          {denominations.map((amount) => (
            <button
              key={amount}
              onClick={() => setSelectedDenomination(amount)}
              className={`filter-button ${selectedDenomination === amount ? "active" : ""}`}
            >
              ₦{amount}
            </button>
          ))}
        </div>

        <div className="filter-group">
          <button
            onClick={() => setSelectedNetwork("all")}
            className={`filter-button ${selectedNetwork === "all" ? "active" : ""}`}
          >
            All Networks
          </button>
          {networks.map((net) => (
            <button
              key={net}
              onClick={() => setSelectedNetwork(net)}
              className={`filter-button ${selectedNetwork === net ? "active" : ""}`}
            >
              {net}
            </button>
          ))}
        </div>
      </div>

      {/* Recharge Cards */}
      <div ref={printRef}>
        {paginatedPins.length === 0 ? (
          <p className="no-pins">No {view} pins found.</p>
        ) : (
          <ul className="pin-list">
            {paginatedPins.map((pin) => (
              <li key={pin._id} className="pin-card">
                <div className="pin-details">
                  <p><strong>Network:</strong> {pin.network}</p>
                  <p><strong>PIN:</strong> {pin.pin}</p>
                  <p><strong>Serial:</strong> {pin.serial}</p>
                </div>
                <button
                  onClick={() => handleToggleStatus(pin._id)}
                  className="toggle-status-btn"
                >
                  Mark as {pin.status === "used" ? "Not Used" : "Used"}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Pagination */}
      <div className="pagination">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(currentPage - 1)}
        >
          Prev
        </button>
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            className={currentPage === i + 1 ? "active-page" : ""}
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}
        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(currentPage + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default GeneratedPins;
